import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchDateNeighborhood } from '../api/projects.api';
import { queryKeys } from '@/shared/lib/queryKeys';
import type { DateNeighborhoodItem, Id } from '@/shared/types/domain';

/**
 * Vizinhança da data (§6.5): contexto, não lista — a chave mora sob o
 * prefixo `['projects', id]`, de propósito, para que `invalidateAfterTransition`
 * a alcance de graça quando outro projeto da mesma janela mudar de situação.
 */
export function useDateNeighborhood(
  id: Id | undefined,
  branchId: string | undefined,
  startsAt: string | null | undefined,
  endsAt: string | null | undefined,
): UseQueryResult<DateNeighborhoodItem[]> {
  return useQuery({
    queryKey: queryKeys.projects.neighborhood(id ?? ''),
    queryFn: () => fetchDateNeighborhood(branchId as string, startsAt as string, endsAt as string),
    enabled: Boolean(id) && Boolean(branchId) && Boolean(startsAt) && Boolean(endsAt),
    staleTime: 30_000,
  });
}
